/**
 * Message Actions - Centralized constants for actions within each domain
 */
export const MessageActions = {
    // Modal actions
    CLOSE: 'CLOSE',
    OPEN: 'OPEN',
    TOGGLE: 'TOGGLE',
    
    // Feature actions
    SELECT: 'SELECT',
    UNSELECT: 'UNSELECT',
    ENABLE: 'ENABLE',
    DISABLE: 'DISABLE',
    
    // Language actions
    CHANGE: 'CHANGE',
    SET: 'SET',
    
    // Interface actions
    HIDE: 'HIDE',
    SHOW: 'SHOW',
    RESET: 'RESET',
    
    // Navigation actions
    VOICE_START: 'VOICE_START',
    VOICE_STOP: 'VOICE_STOP',
    PAGE_STRUCTURE: 'PAGE_STRUCTURE',
    
    // Color actions
    CHANGE_BACKGROUND: 'CHANGE_BACKGROUND',
    CHANGE_TEXT: 'CHANGE_TEXT',
    
    // Mouse actions
    MOVE: 'MOVE',
} as const;

export type MessageAction = typeof MessageActions[keyof typeof MessageActions];